import React, { useState } from "react";
import { Button, Modal, Tooltip } from "antd";
import Counter from "../Counter";
import defaultProductPic from "../../../images/default-brand.jpg";
import { gotoPdp } from "../../../utils/activityHelper";
import AddOnPurchasePriceWidget from "./AddOnPurchasePriceWidget";
import { useAddOnPurchaseCart } from "./useAddOnPurchaseCart";
import type { AddOnPurchaseCardProps } from "./types";

const AddOnPurchaseProductCard: React.FC<AddOnPurchaseCardProps> = (props) => {
  const { product, loginState, previewFlag } = props;
  const initialQuantity = product.limitQty == null
    ? (product.shoppingQty || 1)
    : Math.min(product.shoppingQty || 1, product.limitQty);
  const [quantity, setQuantity] = useState(initialQuantity);
  const [showGoModal, setShowGoModal] = useState(false);
  const { processing, addToCart } = useAddOnPurchaseCart(props, "pc");
  const showDetails = () => { if (product.pdpViewable) setShowGoModal(true); };
  return (
    <div className="productCardWrapper addOnPurchaseCard">
      <div className="productCard">
        <div className="top">
          <div className="line line1">
            <span>{product.sku}</span>
            <span dangerouslySetInnerHTML={{ __html: product.productSize || "" }} />
          </div>
          <Tooltip title={<div dangerouslySetInnerHTML={{ __html: product.productName || "" }} />}>
            <div className={`line line2 ${product.pdpViewable ? "linkable" : ""}`}
              onClick={showDetails} dangerouslySetInnerHTML={{ __html: product.productName || "" }} />
          </Tooltip>
          {product.description && (
            <Tooltip title={product.description}>
              <div className="line line3" dangerouslySetInnerHTML={{ __html: product.description }} />
            </Tooltip>
          )}
          <div className="line line4">
            <div className="imgWrapper">
              <img alt={product.productName} src={product.productPic || defaultProductPic} onClick={showDetails} />
            </div>
            <AddOnPurchasePriceWidget product={product} loginState={loginState} />
          </div>
        </div>
        <div className="line line5">
          <Counter value={quantity} onChange={setQuantity} maxQuantity={product.limitQty ?? undefined}
            login={loginState.status === "login"}
            product={{ ...product, priceStatus: product.priceStatus || undefined, shoppingQty: quantity }} />
          <Button className="primaryBtn addCartBtn" loading={processing}
            disabled={processing || (loginState.status === "login" && (!!previewFlag || !product.available))}
            onClick={(event) => { event.stopPropagation(); addToCart(quantity); }}>
            {loginState.status !== "login" || product.available ? "加购" : "已售罄"}
          </Button>
        </div>
      </div>
      <Modal title="提示" open={showGoModal} getContainer={document.body} style={{ top: "35%" }}
        className="show-go-to-detail-info-modal" onCancel={() => setShowGoModal(false)}
        footer={[
          <Button key="ok" onClick={() => { setShowGoModal(false); gotoPdp(product, loginState, "Activity_Detail"); }}>
            继续前往
          </Button>,
          <Button key="cancel" type="primary" onClick={() => setShowGoModal(false)}>留在本页</Button>,
        ]}>
        <p>该促销仅限当前页面加购才可享受，浏览产品详情后需返回本页面参与。</p>
      </Modal>
    </div>
  );
};
export default AddOnPurchaseProductCard;
